module.exports = __webpack_public_path__ + "img/618.Clogged_sink_malfunction.f4b4afc2.svg";